import { dynamic } from '#/utils/dynamic';

export const orgDashboardModalComponentByType = {
  SHARE_NEW_LISTING: dynamic(
    () =>
      import('./ShareNewListing/ShareNewListingModal').then((module) => ({
        default: module.ShareNewListingModal,
      })),
    { strategy: 'always' },
  ),
  DELETE_LISTING: dynamic(
    () =>
      import('./DeleteListing/OrgDashboardDeleteListingModalContainer').then(
        (module) => ({
          default: module.OrgDashboardDeleteListingModalContainer,
        }),
      ),
    { strategy: 'always' },
  ),
  DELETE_ORG: dynamic(
    () =>
      import('./DeleteOrg/DeleteOrgModalContainer').then((module) => ({
        default: module.DeleteOrgModalContainer,
      })),
    { strategy: 'always' },
  ),
  VAT_NUMBER: dynamic(
    () =>
      import('./VatNumber/VatNumberModalContainer').then((module) => ({
        default: module.VatNumberModalContainer,
      })),
    { strategy: 'always' },
  ),
  HIDE_REPOSTED_LISTINGS: dynamic(
    () =>
      import('./OrgHideRepostedListings/OrgHideRepostedListingsModalContainer').then(
        (module) => ({ default: module.OrgHideRepostedListingsModalContainer }),
      ),
    { strategy: 'always' },
  ),
  CONTACT_CANDIDATE: dynamic(
    () =>
      import('./ContactCandidate/ContactCandidateModal').then((module) => ({
        default: module.ContactCandidateModal,
      })),
    { strategy: 'always' },
  ),
  AUTO_PUBLISH_INTEGRATION: dynamic(
    () =>
      import('./AutoPublishIntegration/AutoPublishIntegrationModalContainer').then(
        (module) => ({ default: module.AutoPublishIntegrationModalContainer }),
      ),
    { strategy: 'always' },
  ),
  DELETE_INTEGRATION: dynamic(
    () =>
      import('./DeleteIntegration/DeleteIntegrationModalContainer').then(
        (module) => ({ default: module.DeleteIntegrationModalContainer }),
      ),
    { strategy: 'always' },
  ),
  CHECKOUT_FEEDBACK: dynamic(
    () =>
      import('./CheckoutFeedback/CheckoutFeedbackModal').then((module) => ({
        default: module.CheckoutFeedbackModal,
      })),
    { strategy: 'always' },
  ),
} as const satisfies Record<string, unknown>;
